import { FC, ReactNode } from 'react';
import { styled } from '@mui/material';

export interface ContainerProps {
  children: ReactNode;
}

const StyledContainer = styled('div', {
  name: 'AppBar',
  slot: 'Container',
})(({ theme }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'row',
  flex: 1,
  gap: '32px',
  alignItems: 'center',
  color: theme.palette.text.primary,
}));

const Container: FC<ContainerProps> = (props) => {
  return <StyledContainer {...props} />;
};

Container.displayName = 'AppBar.Container';

export default Container;
